import * as React from 'react';

import { PropertySearchLink } from '@shared-ui/lodging-property-offers';

import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

const PropertySearchLinkWrapper: React.FC<SharedUiWrapperProps> = ({ inputs }) => <PropertySearchLink inputs={inputs} skipSsr={true} />;

PropertySearchLinkWrapper.displayName = 'SharedUiPropertySearchLinkWrapper';
export const SharedUiPropertySearchLinkWrapper = withSharedUiPropertyOffers(PropertySearchLinkWrapper);
